<div *ngIf="!isMobileView()">
    <ng-container *ngIf="headerTemplate">
        <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
    </ng-container>
    <ng-container *ngTemplateOutlet="content"></ng-container>
</div>

<ion-modal
    class="sheet-modal duration-200 ease-out will-change-transform focus:outline-transparent"
    id="modal"
    *ngIf="isMobileView() && initialBreakpoint && !isMobileHeaderMenuOpen()"
    [class.transition-transform]="!isDragging"
    [initialBreakpoint]="initialBreakpoint"
    [breakpoints]="breakpoints"
    [style.--border-radius]="'1rem 1rem 0 0'"
    [ngStyle]="{ transform: 'translateY(${rubberOffset}px)' }"
    (didPresent)="onModalDidPresent()"
    (willPresent)="onModalPresent()"
    (ionBreakpointDidChange)="onModalBreakpointDidChange($event)"
    backdrop-breakpoint="1"
    is-open="true"
    backdrop-dismiss="false"
    handleBehavior="cycle">
    <ng-template>
        <ng-container *ngIf="headerTemplate">
            <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
        </ng-container>
        <ion-content
            class="dark:bg-black"
            #scrollContainer
            [scrollEvents]="true"
            (touchstart)="onTouchStart($event)"
            (touchmove)="onTouchMove($event)"
            (touchend)="onTouchEnd()"
            (ionScroll)="onScroll($event)"
            scrollY="true"
            forceOverscroll="false">
            <div class="!flex flex-col" [class.min-h-full]="isFullHeightContainer">
                <section
                    class="h-full w-full grow bg-grey-white_smoke dark:bg-contrast-black"
                    [ngClass]="this.env.IS_MOBILE_APP ? 'container__modal' : 'pb-24'">
                    <ng-container *ngTemplateOutlet="content"></ng-container>
                </section>
            </div>
        </ion-content>
    </ng-template>
</ion-modal>

<ng-template #content>
    <ng-content></ng-content>
</ng-template>
